import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  candidateExp,
  deleteExp,
  deleteExpById,
} from "./ExperienceAPI";

const initialState = {
  value: 0,
  status: "idle",
  experience: [],
  department: [],
  deleteExpResponse: {},
};

export const candidateExpAsync = createAsyncThunk(
  "candidate-dashboard/candidate-experience",
  async (token) => {
    const response = await candidateExp(token);
    console.log("response async : ", response);
    return response;
  }
);


export const deleteExpAsyn = createAsyncThunk(
  "candidate-dashboard/experience",
  async ({ token, uuid }) => {
    // console.log("token:- ", token, " id: ", id);
    const response = await deleteExp(token, uuid);
    console.log("response async : ", response);
    return response;
  }
);
export const candidateExperienceSlice = createSlice({
  name: "candidate-dashboard",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(candidateExpAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(candidateExpAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.experience = action.payload;
      })
      .addCase(deleteExpAsyn.pending, (state, action) => {
        state.status = "idle";
      })
      .addCase(deleteExpAsyn.fulfilled, (state, action) => {
        state.status = "idle";
        state.deleteExpResponse = action.payload;
      });
  },
});

export const selectFetchedExperience = (state) =>
  state.candidateExperience?.experience?.employment;
export const selectDeleteexpResponse = (state) =>
  state.candidateExperience?.deleteExpResponse;
export default candidateExperienceSlice.reducer;
